import { Box, Button, Container, Typography, Grid, Link, makeStyles } from '@material-ui/core'
import React from 'react'
import { SectionHeaderSmall, TitleH2Bold } from '../../theme/typography'
import SelectDevice from './SelectDevice'
import VideoPulseButton from '../Video/VideoPulseButton'
import FreeTrialBanner from './FreeTrialBanner'
import PropTypes from 'proptypes'
import styled from 'styled-components'
import { placeImage, uppercaseString } from '../../utils'
import { GatsbyImage } from 'gatsby-plugin-image'

import Svg from 'react-inlinesvg'
import WatchBg1 from '../../images/bgimages/watch-bg1.svg'
import WatchBg2 from '../../images/bgimages/watch-bg2.svg'
import WatchBg3 from '../../images/bgimages/apple-watch-bg.svg'
import CombinedBlue from '../../images/bgimages/combined-blue.svg'
import Simple from '../../images/bgimages/simple.svg'
import Big from '../../images/bgimages/big.svg'

const useStyles = makeStyles((theme) => ({
  phoneBgImage: {
    position: 'absolute !important',
    right: -150,
    bottom: 250,
    width: 190,
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'block',
      bottom: 'auto',
      top: -50
    }
  },
  phoneBgImage2: {
    position: 'absolute !important',
    zIndex: -1,
    right: (props) => (props.watch ? -200 : 0),
    bottom: (props) => (props.watch ? -150 : 0),
    display: 'none',
    width: (props) => (props.watch ? 400 : props.phone ? 100 : 'auto'),
    height: (props) => (props.watch ? 400 : props.phone ? 100 : 'auto'),
    opacity: (props) => (props.watch ? 0.7 : 1),
    [theme.breakpoints.up('md')]: {
      display: 'block'
    }
  },
  phoneBgImage4: {
    position: 'absolute !important',
    left: 'auto',
    bottom: 0,
    maxWidth: '100%',
    display: 'none',
    [theme.breakpoints.up('md')]: {
      bottom: -90,
      display: 'block'
    }
  },
  watchBgImage: {
    position: 'absolute !important',
    right: -300,
    bottom: -100,
    maxWidth: '100%',
    [theme.breakpoints.up('lg')]: {
      right: -200
    }
  },
  watchBgImage2: {
    position: 'absolute !important',
    left: -150,
    bottom: -170,
    maxWidth: '100%',
    [theme.breakpoints.up('lg')]: {
      left: -70
    }
  },
  watchBgImage3: {
    position: 'absolute !important',
    right: 0,
    bottom: 0,
    [theme.breakpoints.up('md')]: {
      right: -300
    },
    [theme.breakpoints.up('lg')]: {
      right: 0
    }
  }
}))

const WrapBox = styled(Box)(
  ({ theme, fullwidth, bgcolor, color, bgimage, banner, tablet, watch, watchA, phone }) => ({
    backgroundColor: bgcolor === 'dark' ? theme.colors.blue1 : 'transparent',
    color: color === '#ffffff' ? theme.colors.white : theme.colors.blue5,
    padding: banner
      ? theme.spacing(7, 0)
      : watch
      ? theme.spacing(3, 0)
      : phone
      ? theme.spacing(12, 0, 7)
      : theme.spacing(8, 0),
    paddingBottom: watchA ? 0 : theme.spacing(7),
    textAlign: fullwidth ? 'center' : 'center',
    zIndex: watch ? 0 : 2,
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      paddingTop:
        banner || watchA ? theme.spacing(10) : watch ? theme.spacing(7) : theme.spacing(10)
    },
    [theme.breakpoints.up('md')]: {
      textAlign: fullwidth ? 'center' : 'left',
      '&::before': {
        content: '""',
        position: 'absolute',
        zIndex: -1,
        width: '100%',
        height: '100%',
        left: 0,
        bottom: 0,
        backgroundImage: bgimage ? `url(${bgimage})` : 'none',
        backgroundSize: 'contain',
        backgroundPosition: tablet ? 'center bottom' : '100% 101%',
        backgroundRepeat: 'no-repeat'
      }
    },
    '@media (min-width: 1400px)': {
      backgroundImage:
        bgcolor === 'gradient'
          ? `linear-gradient(to bottom, ${theme.colors.white}, ${theme.colors.cream} 50%, ${theme.colors.cream})`
          : 'none'
    }
  })
)
const ButtonsBox = styled(Box)(({ theme, fullwidth, nomarginbottom }) => ({
  margin: theme.spacing(2.5, -1, 3),
  marginBottom: nomarginbottom ? 0 : theme.spacing(3),
  justifyContent: fullwidth ? 'center' : 'flex-start',
  '& a': {
    margin: theme.spacing(1)
  },
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'center'
  }
}))
const ContainerWrap = styled(Container)(({ banner }) => ({
  position: 'relative',
  zIndex: 1,
  minHeight: banner ? 355 : 100,
  display: banner ? 'flex !important' : 'block',
  alignItems: 'center'
}))
const Content = styled(Typography)(({ theme, color }) => ({
  position: 'relative',
  zIndex: 1,
  '& a': {
    color: color === '#ffffff' ? theme.colors.white : theme.colors.blue1,
    '&:hover': {
      color: color === '#ffffff' ? theme.colors.white : theme.colors.blue1
    }
  }
}))
const GridWrap = styled(Grid)(({ watch }) => ({
  justifyContent: 'center',
  alignItems: watch ? 'center' : 'stretch'
}))
const GridImage = styled(Grid)(({ theme, fullwidth }) => ({
  position: 'relative',
  marginTop: fullwidth ? theme.spacing(6) : 0
}))
const TitleTop = styled(SectionHeaderSmall)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  textTransform: 'none'
}))
const ImageRight = styled(GatsbyImage)(
  ({ theme, fullwidth, watch, watchA, phone, banner, hidemobile, tablet }) => ({
    position: 'relative',
    maxWidth: 370,
    marginBottom: phone || banner ? '-8rem' : '-3rem',
    width: '100%',
    display: hidemobile ? 'none' : 'block',
    '@media (min-width: 500px)': {
      maxWidth: 500
    },
    [theme.breakpoints.up('sm')]: {
      maxWidth: banner ? 500 : tablet ? 789 : watch || watchA ? 450 : '100%',
      top: phone ? -theme.spacing(2) : 0,
      display: hidemobile ? 'none' : 'block',
      width: watch ? 'auto' : '85%',
      minWidth: banner ? 500 : phone ? 450 : 0,
      position: fullwidth || watch || watchA || banner ? 'relative' : 'absolute',
      right: 0,
      left: '50%',
      transform: 'translateX(-50%)',
      marginBottom: banner ? '-10rem' : 0
    },
    [theme.breakpoints.up('md')]: {
      display: 'block'
    },
    [theme.breakpoints.up('lg')]: {
      marginBottom: watchA ? -80 : 0
    },
    '@media (min-width: 1190px)': {
      marginLeft: watch ? theme.spacing(8) : 0,
      position: fullwidth || watch || watchA ? 'relative' : 'absolute',
      maxWidth: tablet ? 789 : '100%',
      top: phone ? -theme.spacing(7) : banner ? -theme.spacing(10) : 0
    }
  })
)
const PhoneBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(6),
  marginBottom: theme.spacing(4),
  [theme.breakpoints.up('md')]: {
    marginBottom: theme.spacing(-14)
  }
}))
const LeftBox = styled(Box)(({ theme, phone }) => ({
  [theme.breakpoints.up('md')]: {
    padding: phone ? theme.spacing(0, 3) : 0
  }
}))

function HeroConsumer(props) {
  const classes = useStyles(props)
  let selectedDevices = props.selectDevices && props.selectDevices[0]
  return (
    <WrapBox
      fullwidth={props.fullwidth}
      bgcolor={props.bgcolor}
      color={props.color}
      bgimage={props.bgimage}
      banner={props.banner}
      tablet={props.tablet}
      watch={props.watch ? true : undefined}
      watchA={props.watchA}
      phone={props.phone}
    >
      {props.watch && (
        <>
          <Svg placeholder="none" className={classes.watchBgImage} src={WatchBg1} alt="" />
          <Svg className={classes.watchBgImage2} src={WatchBg2} alt="" />
        </>
      )}
      {props.watchA && (
        <>
          <Svg className={classes.watchBgImage3} src={WatchBg3} alt="" />
        </>
      )}
      <ContainerWrap maxWidth="lg" banner={props.banner}>
        {props.phone && (
          <>
            <Svg className={classes.phoneBgImage} src={CombinedBlue} alt="bg-circle" />
            <Svg
              className={classes.phoneBgImage2}
              watch={props.watch ? true : undefined}
              src={Simple}
              alt="bg-circle2"
            />
          </>
        )}
        <GridWrap
          container
          spacing={props.fullwidth ? 0 : 4}
          watch={props.watch ? 'true' : undefined}
        >
          <Grid item xs={12} md={props.fullwidth ? 9 : 6} alignItems="center">
            <LeftBox phone={props.phone}>
              <TitleTop component="h1" gutterBottom>
                {uppercaseString(props.topText)}
              </TitleTop>

              <TitleH2Bold component="h2" gutterBottom style={{ textTransform: 'none' }}>
                {uppercaseString(props.title)}
              </TitleH2Bold>

              <Content
                variant="body1"
                component="div"
                color={props.color ? props.color : 'textSecondary'}
                dangerouslySetInnerHTML={{ __html: props.content }}
              />
              {props.freeTrialBanner && <FreeTrialBanner {...props.freeTrialBanner[0]} />}
              {props.ctas && (
                <ButtonsBox
                  display="flex"
                  flexWrap="wrap"
                  fullwidth={props.fullwidth}
                  nomarginbottom={props.noMarginBottom ? 'true' : undefined}
                >
                  {props.ctas.map((cta, i) => {
                    return cta.image ? (
                      <Link
                        href={cta.href}
                        target={cta.openIn}
                        rel={cta.rel}
                        title={cta.title}
                        data-app-store={cta.appStore}
                      >
                        {placeImage(cta.image)}
                      </Link>
                    ) : (
                      <Button
                        href={cta.href}
                        title={cta.title}
                        rel={cta.rel}
                        target={cta.target}
                        variant="contained"
                        color={cta.color ? 'secondary' : i === 0 ? 'primary' : 'secondary'}
                      >
                        {cta.text}
                      </Button>
                    )
                  })}
                </ButtonsBox>
              )}
            </LeftBox>
            {selectedDevices && !props.fullwidth && (
              <PhoneBox>
                <SelectDevice {...selectedDevices} adsEvent="free-trial" />
              </PhoneBox>
            )}
          </Grid>

          <GridImage item xs={12} md={props.fullwidth ? 12 : 6} fullwidth={props.fullwidth}>
            {props.phone && (
              <Svg className={classes.phoneBgImage4} src={Big} alt="bg-circles-big" />
            )}
            {props.image && (
              <ImageRight
                watch={props.watch}
                watchA={props.watchA}
                fullwidth={props.fullwidth}
                bgcolor={props.bgcolor}
                image={props.image.gatsbyImageData}
                alt={props.imageAlt}
                phone={props.phone}
                tablet={props.tablet}
                banner={props.banner}
                hidemobile={props.freeTrialBanner || props.hidemobile}
              />
            )}
            {props.videoUrl && (
              <VideoPulseButton
                videoUrl={props.videoUrl}
                tablet={props.tablet}
                consumer={true}
                watch={props.watchA}
              />
            )}
          </GridImage>
        </GridWrap>

        {selectedDevices && props.fullwidth && (
          <Box mt={9} mb={props.phone ? 5 : -12}>
            <SelectDevice {...selectedDevices} adsEvent="get-started-ipad" />
          </Box>
        )}
      </ContainerWrap>
    </WrapBox>
  )
}

export default HeroConsumer

HeroConsumer.propTypes = {
  banner: PropTypes.bool,
  topText: PropTypes.string,
  title: PropTypes.string,
  content: PropTypes.string,
  bgimage: PropTypes.string,
  image: PropTypes.string,
  ctas: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      href: PropTypes.string
    })
  )
}
